import { render } from "./NavItem.vue?vue&type=template&id=7aed89e6&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=7aed89e6&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aed89e6"]])

export default __exports__